import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=7d23df60&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=7d23df60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23df60",
  null
  
)

export default component.exports